
export default ({
  treatment,
  name,
  first_name: firstName,
  last_name: lastName,
  mothers_last_name: secondLastName
}) => {
  return `${treatment !== undefined ? treatment : ''} ${name || firstName} ${lastName || ''} ${secondLastName || ''}`.trim()
}
